/* tslint:disable */
/* eslint-disable */
/* @relayHash b859be5f097d655a5521015fa6f9319b */

import { ConcreteRequest } from "relay-runtime";
export type InteriorPhotoWrapperQueryVariables = {
    projectRootId: string;
};
export type InteriorPhotoWrapperQueryResponse = {
    readonly viewer: {
        readonly designProjectRootSearch: {
            readonly tradePhotos: ReadonlyArray<{
                readonly url: string | null;
                readonly serviceId: string | null;
                readonly path: string | null;
                readonly width: number | null;
                readonly height: number | null;
            } | null> | null;
        } | null;
    };
};
export type InteriorPhotoWrapperQuery = {
    readonly response: InteriorPhotoWrapperQueryResponse;
    readonly variables: InteriorPhotoWrapperQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "projectRootId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "projectRootId",
    "variableName": "projectRootId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "InteriorPhotoWrapperQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "designProjectRootSearch",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradePhotos",
                "storageKey": null,
                "args": null,
                "concreteType": "TradePhoto",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "InteriorPhotoWrapperQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "designProjectRootSearch",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "DesignProjectRootSearchResult",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradePhotos",
                "storageKey": null,
                "args": null,
                "concreteType": "TradePhoto",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          },
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "InteriorPhotoWrapperQuery",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/InteriorPhotoWrapperQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'f2e0bed36631696b6fb912568b930302';
export default node;
